import { SvgIcon, SxProps } from "@mui/material";
import Icon from "jsx:../../../Images/Icons/Custom/GameTimeline/rectangle-vertical-solid_red.svg";

export function RectangleVerticalSolidRed(props: SxProps) {
    return <SvgIcon component={Icon} inheritViewBox sx={props} />;
}
